export * from './dealer-req-doc-config-list.component';
